
<template>
  <v-card class="campaign-card ">
    <v-row no-gutters>
      <!-- Columna esquerra -->
      <v-col cols="4" class="pa-4">
        <h3 class="title">{{ title }}</h3>
        <p class="id">{{ code }}</p>
        <p class="txt_blau">TIPO: {{ MostrarServei }}</p>
        <p class="txt_blau">UNIDADES CONTRATADAS: <span class="highlight">{{ formatNumber(txtTotalUnits) }}</span></p>
        <p class="subtitol">UNIDADES REPARTIDAS: <span class="highlight">{{ formatNumber(txtTotalUnitsRepartides) }}</span></p>
      </v-col>

      <!-- Columna central -->
      <v-col cols="4" class="pa-4" style="margin-top: 30px;">
        <v-row class="dates-row" justify="space-between">
          <div>
            <span class="date-label">Fecha Inicio</span><br>
            <span class="date-value">{{ formatDate(dateFrom) }}</span>
          </div>
          <div class="text-right">
            <span class="date-label">Fecha Final</span><br>
            <span class="date-value">{{ formatDate(dateTo) }}</span>
          </div>
        </v-row>
        <v-progress-linear
          :model-value="completion"
          color="#00aaff"
          height="30"
          rounded
          class="mt-8"
        >
          <template #default="{ value }">
            <strong style="color:white;">{{ value.toFixed(0) }}%</strong>
          </template>
        </v-progress-linear>

      </v-col>

      <!-- Columna dreta -->

      <v-col cols="4" class="pa-4">
        <!-- Fila 1: Contador -->
        <v-row class="mb-4 ">
          <v-col cols="10" class="text-right">
            <span class="counter-title">{{ KPI_punts_txt}}</span>
          </v-col>
          <v-col cols="2" class="justify-end gap-2">
            <span class="counter-value">{{ formatNumber(KPI_punts_valor) }}</span>
            <v-btn icon color="#00b3cf" size="small" density="compact" class="eye-btn"  @click="emit('openModalFotos')" v-if="controlPointsCount>0">
              <v-icon size="18">mdi-eye</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Fila 2: Servicios -->
        <v-row class="align-start justify-end">
          <span class="counter-title mr-4">SERVICIOS</span>

          <div class="d-flex flex-column align-end gap-2 service-container">
            <!-- Buzoneo -->
            <v-btn
              v-if = " servei !== 'nobm'"
              :variant="servei === 'bm' ? 'flat' : 'outlined'"
              color="#00b3cf"
              class="service-btn small-text"
              rounded
              block
              :aria-pressed="servei === 'bm'"
              @click="CanviServei('bm')"
            >
              Buzoneo
            </v-btn>

            <!-- Entrega en tienda -->
            <v-btn 
              v-if = "quantitatBotiguesET > 0"
              :variant="servei === 'et' ? 'flat' : 'outlined'"
              color="#00b3cf"
              class="service-btn small-text"
              rounded
              block
              :aria-pressed="servei === 'et'"
              @click="CanviServei('et')"
            >
              Entrega en tienda
            </v-btn>

            <!-- NOBM : serveis especials no buzoneo (azafatas) -->
            <v-btn 
              v-if = "servei === 'nobm'"
              :variant="servei === 'nobm' ? 'flat' : 'outlined'"
              color="#00b3cf"
              class="service-btn small-text"
              rounded
              block
              :aria-pressed="servei === 'nobm'"
              @click="CanviServei('nobm')"
            >
              {{ MostrarServei }}
            </v-btn>
          </div>
        </v-row>

      </v-col>
    </v-row>
  </v-card>
</template>



<!-- src/components/CampaignOverview.vue -->
<script setup lang="ts">
import { ref, watchEffect } from 'vue'
import { formatNumber, formatDate } from '@/utils/text-utils'

type ControlPoint = {
  id: number
  name: string
  type: string   // ex.: 'BM'
  weight: string // ex.: '1:39 grs'
}
const ampliaImg = ref(false)
const emit = defineEmits<{
  (e: 'openModalFotos'): void
  (e: 'updateServei', value: string): void   
}>()

const props = withDefaults(defineProps<{
  title: string
  code: string
  dateFrom: string  
  dateTo: string   
  productName: string
  productCode?: string
  productWeight?: string
  controlPointsCount: number
  quantitatBotiguesET: number
  totalUnits: number
  deliveredUnits: number
  pendingUnits: number
  totalUnitsET: number
  deliveredUnitsET: number
  pendingUnitsET: number
  imageUrl?: string
  loading?: boolean,
  idCampET: null,
  nomServeiInicial: string
}>(), {
  productCode: '',
  productWeight: '',
  imageUrl: '',
  loading: false,
})

const servei = ref('bm')
const completion = ref(0)
const MostrarServei = ref("Buzoneo Masivo")
const KPI_punts_txt = ref("CONTADOR DE PUNTOS DE CONTROL")
const KPI_punts_valor = ref(0)
const KPI_punts_boto = ref(true)

const txtTotalUnits = ref(0)
const txtTotalUnitsRepartides = ref(0)

// Inicia amb les dades pasades per Props, pero com que carrega mes lent es necessita aquesta funcio
watchEffect(() => {
  const total = props.totalUnits
  const delivered = props.deliveredUnits

  // Revisar el servei inicial, per si no es un buzoneo i per exemple es azafatas
  if (props.nomServeiInicial && !props.nomServeiInicial?.toLowerCase().includes('buz')) {
    CanviServei(props.nomServeiInicial)
    return
  }

  if (total == null || delivered == null) {
    // NO fer res fins que les props tinguin valor real
    return
  }

  txtTotalUnits.value = total
  txtTotalUnitsRepartides.value = delivered
  KPI_punts_valor.value = props.controlPointsCount

  completion.value = total === 0
    ? 0
    : Math.min(100, Math.round((delivered / total) * 10000) / 100)
})




function CanviServei(newServei: string) {
  servei.value = newServei
  emit('updateServei', servei.value) 

  if (servei.value === 'bm') {
    MostrarServei.value = "Buzoneo Masivo"
    KPI_punts_txt.value = "CONTADOR DE PUNTOS DE CONTROL"   
    KPI_punts_valor.value = props.controlPointsCount
    KPI_punts_boto.value = true
    txtTotalUnits.value = props.totalUnits
    txtTotalUnitsRepartides.value = props.deliveredUnits

    const total = props.totalUnits || 0
    if (!total) completion.value = 0
    else completion.value = Math.min(100, Math.round((props.deliveredUnits / total) * 10000) / 100)

  } else if (servei.value === 'et') {
    MostrarServei.value = "Entrega en tienda"
    KPI_punts_txt.value = "NÚMERO DE TIENDAS"
    KPI_punts_valor.value = props.quantitatBotiguesET
    KPI_punts_boto.value = false
    txtTotalUnits.value = props.totalUnitsET
    txtTotalUnitsRepartides.value = props.deliveredUnitsET

    const total = props.totalUnitsET || 0
    if (!total) completion.value = 0
    else completion.value = Math.min(100, Math.round((props.deliveredUnitsET / total) * 10000) / 100)
    
  } else {
    // Nou apartat per serveis que no són Buzoneo ni ET, pero vull que es tracti com ET canviant els noms
    servei.value = 'nobm'
    MostrarServei.value = props.nomServeiInicial || servei.value
    KPI_punts_txt.value = ""
    KPI_punts_valor.value = ""
    KPI_punts_boto.value = false
    txtTotalUnits.value = props.totalUnits
    txtTotalUnitsRepartides.value = props.deliveredUnits

    const total = props.totalUnitsET || 0
    completion.value = !total
      ? 0
      : Math.min(100, Math.round((props.deliveredUnitsET / total) * 10000) / 100)
  }

}
</script>


<style scoped>


.counter-title {
  font-size: 14px;
  font-weight: bold;
}
.counter-value {
  color: #00b3cf;
  font-weight: bold;
  font-size: 18px;
}
.eye-btn {
  margin-left: 8px;
}
.service-btn {
  font-weight: bold;
  text-transform: none;
  font-size: 12px;
}
.dates-row {
  display: flex;
  justify-content: space-between;
}


.service-container {
  width: 160px; 
}

.gap-2 {
  gap: 8px;
}

</style>